import { map } from "rxjs";
import { Token } from "../../model";
import { apiService } from "../ApiService";

export const getUserToken = (profileId: string, pin?: string) => {
  return apiService
    .post<{ userToken: Token }>({
      path: `v1/family/token`,
      body: {
        profileId,
        pin,
      },
      requiresAuthPolicy: "family",
    })
    .pipe(
      map(({ userToken }) => {
        apiService.userToken = userToken;
        return userToken;
      }),
    );
};
